import PropertyListView from '../view'

export default class PropertyFutureListView extends PropertyListView {

    constructor(controller) {
        super(controller)
    }

    propertyTabs(projekts, objekts, areas, removeEmpty = true) {
        return super.propertyTabs(projekts, objekts, areas, removeEmpty)
    }

}
